import { sendEmailVerification } from 'firebase/auth';

export function useSendEmailVerification() {
  return sendEmailVerification;
}
